// schema.ts
import { z } from "zod";

export const unlockTimesheetSchema = z.object({
  date: z.string().min(1, { message: "Date is required" }),
  justification: z.string().min(1, { message: "Justification is required" }),
});
